// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"2ad2020e","157":"6fc55448","373":"d12acb96","567":"7a1a0ac8","787":"3050b443","790":"61b52d54","808":"4ffdbdb9"}[chunkId] + ".chunk.js";
};